module.exports = __webpack_public_path__ + "img/gratitude-journal_B095L6X5LT.51e5abde.jpg";